import { Route } from "react-router-dom";
import Layout from "../Layout";
import EventSpecificDetails from "../../view/application/event-management/EventSpecificDetails";

const eventRoutes = (
    <Route element={<Layout />}>
        <Route path="/e/:eventSlug" element={<EventSpecificDetails />} />
    </Route>
);

export default eventRoutes;

/**
 * http://192.168.29.243:3000/e/Test-Multi-date-gaps-with-slots-Draft-status/code=b2e43235-afa5-40c0-825a-d32ee726a695
 * 
 * 1. Extract the code from this url and make a request to backend to verify this code.
 *    Done on this url -> "/e/:eventSlug/:inviteCode"
 *    In backend response do following things:
 *    1. Store session id in users localStorage
 *    2. If there is a custom token then (For normal user)
 *       1. make a signInWithCustomToken.
 *       2. After successful login again make request to backend the the stored session id. here the backend will gives type. is it staff or not. if it is staff then redirect to /e/:eventSlug/scan page and if it is attendee then redirect to /e/:eventSlug/attendee page
 *    3. If there is not custom token in response. (means user is guest)
 *       1. Make a signInAnnonimously using firebase
 *       2. Make a backend request with sessionId to tell backend that user has been logged in
 *          As a response backend will give type. If type is staff then redirect to /e/:eventSlug/scan page and if type is attendee then redirect to /e/:eventSlug/attendee page
 * 
 * TODO List — Invite Code Verification Flow
1. Setup Route
Create route: /e/:eventSlug/:inviteCode
Create component: VerifyInviteCode.jsx

2️. Extract Params
Use useParams() to get:
eventSlug
inviteCode

3. Verify Invite Code (Backend)
Call backend API:
GET /api/v2/events/:eventSlug/code/:inviteCode (or whatever your endpoint is)

On success, store:

1. sessionId → localStorage.setItem("sessionId", sessionId)

2. If customToken Exists (Normal User)

3. Call signInWithCustomToken(firebaseAuth, customToken)

On successful login:

1. Call backend again with sessionId to fetch type (staff or attendee)

2. If type === "staff" → navigate(/e/:eventSlug/scan-page, { replace: true })

3. If type === "attendee" → navigate(/e/:eventSlug/attendee, { replace: true })

5. If customToken Missing (Guest User)

Call signInAnonymously(firebaseAuth)

On successful anonymous login:

1. Call backend with sessionId to notify login

Backend returns type

1. If type === "staff" → navigate(/e/:eventSlug/scan-page, { replace: true })

2. If type === "attendee" → navigate(/e/:eventSlug/attendee, { replace: true })
 */